import { axiosInstanceIntegraciones } from '../../../utils/axiosGlobalUtils'
import { CsvEquivalencia, ImportarData } from '../Importacion/types/importacion'
import { SaveAtributos } from '../types'

// Impo
export const GetCSVTemplate = async (tenant: string, codLocal: string) =>
  await axiosInstanceIntegraciones.get(`/${tenant}/locales/${codLocal}/csv/template`)

export const ImportarCSV = async (tenant: string, codLocal: string, data: ImportarData[], reemplazarIds: boolean) =>
  await axiosInstanceIntegraciones.post(
    `/${tenant}/locales/${codLocal}/csv/import?reemplazarIDs=${reemplazarIds}`,
    data
  )

export const SetCSVEquivalencias = async (tenant: string, codLocal: string, equivalencias: CsvEquivalencia[]) =>
  await axiosInstanceIntegraciones.post(`/${tenant}/locales/${codLocal}/equivalencias/csv`, equivalencias)

export const SetRubrosEquivalencias = async (tenant: string, codLocal: string, equivalencias: any[]) =>
  await axiosInstanceIntegraciones.post(`/${tenant}/locales/${codLocal}/equivalencias/rubros`, equivalencias)

export const GetRubrosEquivalencias = async (tenant: string, codLocal: string) =>
  await axiosInstanceIntegraciones.get(`/${tenant}/locales/${codLocal}/equivalencias/rubros`)

export const SetAtributosEquivalencias = async (tenant: string, codLocal: string, equivalencias: SaveAtributos[]) =>
  await axiosInstanceIntegraciones.post(`/${tenant}/locales/${codLocal}/equivalencias/atributos`, equivalencias)
